import axios from "../../util/axios";

const PREFIX_URI = "/luqiao/safety/records";

export default {
    /** 列表数据 */
    queryList: (data) => axios.post({url: `${PREFIX_URI}/queryList`, data}),
    /** 详情 */
    findById: (id) => axios.get({url: `${PREFIX_URI}/findById`, data: {id}}),



}